/**
 * Durable, per-seller onboarding-completion marker.
 *
 * The streamlined account-type onboarding creates NO shop, so completion has no
 * shop-scoped backend home (the only durable store today is
 * `additional_stats.is_dashboard_onboarding_complete`, which a no-shop user can
 * never write). We therefore mark completion in a seller-scoped localStorage key
 * that `localStorageHardReset` preserves across logout — so a returning user is
 * not re-trapped in onboarding on the next login.
 *
 * NOTE: this is browser-local (a new device / incognito session will re-show the
 * one-step account-type screen once). The fully cross-device fix is a
 * seller-level `onboarding_completed` column on the backend, read on init.
 */
const PREFIX = 'adup_onboarding_done_';

const keyFor = (sellerId?: string | number | null): string | null => {
  if (sellerId === undefined || sellerId === null || sellerId === '') {
    return null;
  }
  return `${PREFIX}${sellerId}`;
};

export function markOnboardingComplete(sellerId?: string | number | null): void {
  const key = keyFor(sellerId);
  if (!key) return;
  try {
    window.localStorage.setItem(key, '1');
  } catch (_e) {
    // best-effort; redux flag is the in-session source of truth
  }
}

export function isOnboardingCompleteLocally(
  sellerId?: string | number | null
): boolean {
  const key = keyFor(sellerId);
  if (!key) return false;
  try {
    return window.localStorage.getItem(key) === '1';
  } catch (_e) {
    return false;
  }
}
